<script setup lang="tsx">
import { computed } from 'vue'
import HeaderComponent from '../shared/HeaderComponent.vue'
import IconButton from '../shared/IconButton.vue'
import { PermAllBPWrite, PermBPAdd, PermOwnBPWrite } from '@/models/enums-generated'
import sliderStore from '@/stores/slider'
import { hasPermission, hasPermissionOwn } from '@/services/utils'
import type { Responsible } from '@/models/api-generated'

const props = defineProps<{ bpId: number; bpName: string; responsible: Responsible }>()
const slider = sliderStore()
const canAdd = computed(() => hasPermission(PermBPAdd))
const canEdit = computed(() => hasPermissionOwn(props.responsible, PermAllBPWrite, PermOwnBPWrite))
</script>

<template>
	<HeaderComponent :title="$t('businessProcess')">
		<template #right-side>
			<div class="d-flex align-items-center gap-2">
				<IconButton
					v-if="canAdd && !props.bpId"
					data-test="open-new-bp"
					:title="$t('misc.add')"
					class="bi bi-plus-square"
					@click="slider.openBp"
				>
				</IconButton>
				<IconButton
					v-if="canEdit && props.bpId > 0"
					data-test="edit-bp"
					:title="$t('misc.edit')"
					class="bi bi-pencil"
					@click="slider.openBp(props.bpId, props.bpName)"
				>
				</IconButton>
			</div>
		</template>
	</HeaderComponent>
</template>

<style lang="sass" scoped></style>
